import { Component } from '@angular/core';

@Component({
    selector: 'app-enterprise-layout',
    templateUrl: './enterprise-layout.component.html',
    styleUrl: './enterprise-layout.component.css'
})
export class EnterpriseLayoutComponent {

}
